import { render, staticRenderFns } from "./GalleryEventPictures.vue?vue&type=template&id=cb2442ee&scoped=true"
import script from "./GalleryEventPictures.ts?vue&type=script&lang=ts&external"
export * from "./GalleryEventPictures.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2442ee",
  null
  
)

export default component.exports